import FormType from "../../Components/Form/FormType"
const FormOptions={
    Fields:[
        {element:FormType.Input, required:true, label:"Vessel Name", name:"name", placeholder:"Enter vessel Name"},
    ],
    Buttons:[
      {text:"Save", className:"Btn-Mid Active"}  
    ]
}
export default FormOptions